<template>
    <div v-if="model">
        <rkm-area
            title="Filtros"
            type="fieldset"
            no-margin-top
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col>
                        <rkm-form-date-picker
                            label="Període de"
                            v-model="model.dataInicial"
                            :validations="validations.dataInicial"
                            :max-date="model.dataFinal"
                        />
                    </rkm-col>
                    <rkm-col>
                        <rkm-form-date-picker
                            label="até"
                            v-model="model.dataFinal"
                            :validations="validations.dataFinal"
                            :min-date="model.dataInicial"
                        />
                    </rkm-col>
                    <rkm-col>
                        <rkm-form-select
                            label="Cidade de destino"
                            :options="form.cidades"
                            v-model="model.cidade"
                            show-default-option
                            default-option-text="Todas"
                            text-field="nome"
                            value-field="id"
                        />
                    </rkm-col>
                    <rkm-col>
                        <rkm-form-select
                            label="Local de destino"
                            :options="form.destinos"
                            v-model="model.destino"
                            show-default-option
                            default-option-text="Todos"
                            text-field="descricao"
                            value-field="id"
                        />
                    </rkm-col>
                    <rkm-col>
                        <rkm-button
                            :label="false"
                            color="primary"
                            @click="search"
                        >Buscar</rkm-button>
                        <rkm-button
                            :label="false"
                            @click="reset"
                        >Limpar</rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>
        <rkm-area
            title="Resultado"
            no-margin-top
            v-if="viagens.length"
        >
            <rkm-table
                :fields="fields"
                :items="viagens"
                no-footer-sorting
            >
                <template v-slot:cell(data)="{ item }">
                    {{ item.data | formatDate }}
                </template>

                <template v-slot:cell(actions)="{ item }">
                    <rkm-button
                        color="primary"
                        small
                        title="Reabrir viagem"
                        @click="reopen(item.id)"
                    >
                        <rkm-icon icon="unlock"/>
                    </rkm-button>
                </template>
            </rkm-table>
        </rkm-area>
    </div>
</template>

<script>
import { repository, error } from '@/mixins'
import formats from '@/filters/formats'
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
    filters: {
        formatDate: formats.formatDate,
    },
    computed: {
        validations() {
            return {
                dataInicial: {
                    required: true
                },
                dataFinal: {
                    required: true
                }
            }
        },
        fields() {
            return [
                {
                    key: "data",
                    label: "Data",
                    fixed: true
                },
                {
                    key: "cidade",
                    label: "Cidade",
                    fixed: true
                },
                {
                    key: "destino",
                    label: "Destino",
                    fixed: true
                },
                {
                    key: "veiculo",
                    label: "Veículo",
                    fixed: true
                },
                {
                    key: "motorista",
                    label: "Motorista",
                    fixed: true
                },
                {
                    key: "protocolo",
                    label: "Protocolo",
                    fixed: true
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min',
                    fixed: true
                }
            ]
        }
    },
    created() {
        this.repositories = {
            reabertura: this.getConectaSusRepository('transportePaciente.reaberturaViagem')
        }
        this.load()
    },
    data() {
        return {
            model: null,
            form: null,
            viagens: [],
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()
            this.repositories.reabertura.index()
                .then(({ data }) => {
                    if(data) {
                        this.model = data.model
                        this.form = data.form
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        search() {
            this.$refs.Form.validate()
                .then(valid => {
                    if(!valid) return

                    this.setLoading()
                    this.repositories.reabertura.list({
                        data_inicial: moment(this.model.dataInicial).format('YYYY-MM-DD'),
                        data_final: moment(this.model.dataFinal).format('YYYY-MM-DD'),
                        cidade: this.model.cidade,
                        destino: this.model.destino
                        })
                        .then(({ data }) => {
                            if(data) {
                                this.viagens = data
                            }
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        reopen(id) {
            this.setLoading()
            this.repositories.reabertura.reopen(id)
                .then(() => {
                    this.search()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {
            this.model.dataInicial = null
            this.model.dataFinal = null
            this.model.cidade = null
            this.model.destino = null
            this.form.cidades = []
            this.form.destinos = []
            this.viagens = []
        },
        getCidades() {
            this.setLoading()
            this.repositories.reabertura.getCidades({
                data_inicial: moment(this.model.dataInicial).format('YYYY-MM-DD'),
                data_final: moment(this.model.dataFinal).format('YYYY-MM-DD'),
            })
                .then(({ data }) => {
                    this.form.cidades = data
                    this.model.cidade = null
                    this.model.destino = null
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getDestinos() {
            this.setLoading()
            this.repositories.reabertura.getDestinos({
                data_inicial: moment(this.model.dataInicial).format('YYYY-MM-DD'),
                data_final: moment(this.model.dataFinal).format('YYYY-MM-DD'),
                cidade: this.model.cidade
            })
                .then(({ data }) =>  {
                    this.form.destinos = data
                    this.model.destino = null
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        }
    },
    watch: {
        'model.dataInicial': function() {
            if(this.model.dataFinal && this.model.dataInicial) {
                this.getCidades()
            }
        },
        'model.dataFinal': function() {
            if(this.model.dataInicial && this.model.dataFinal) {
                this.getCidades()
            }
        },
        'model.cidade': function() {
            if(this.model.dataInicial && this.model.dataFinal && this.model.cidade) {
                this.getDestinos()
            } else {
                this.form.destinos = []
            }
        }
    },
    mixins: [ repository, error ]
}
</script>